import React from 'react';
import Page from '@episerver/spa-core/Page';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import BusinessHomepageData from '../../../Models/Content/BusinessHomepageData';

export default class BusinessHomepage extends Page<BusinessHomepageData> {
  render() {
    if (typeof window.scrollTo === "function") { 
      window.scrollTo(0, 0);
    } 
    const {
      data: {mainContentArea},
      context,
    } = this.props;

    return (
      <div className='BusinessHomepage'>
        <div className='BusinessHomepage__headerPlaceholder'></div>
        <ContentArea noWrap context={context} data={mainContentArea} />
      </div>
    );
  }
}
